import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { PersonAdresseListEntryMeta, PersonStammVersionDetailEntryMeta } from '../../../core/gb-api';
import { KompaktdarstellungTemplateComponent } from '../kompakt-darstellung-template.component';
import { NgTemplateOutlet, PlatformLocation, UpperCasePipe } from '@angular/common';
import { ComponentLocationStrategy } from '../../services/location-strategy/component-location-strategy';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { FormatPersonstammAddressPipe } from '../../pipes/format/format-personstamm-address.pipe';
import { Clipboard } from 'ts-clipboard';
import { CapAlertService } from '../../../core/extension/exceptions/cap-alert.service';
import { PersonStammMasterDetailEntryMeta, ZentralePersonDetailEntryMeta } from 'app/core/personstamm-api';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { LinkComponent, LinkTargetWithParamsAndTooltip } from '../../components/link/link.component';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { AppPermissionService } from '../../../core/services/app-permission.service';
import { PermissionResponse } from '../../../core/base-api';
import PermissionsEnum = PermissionResponse.PermissionsEnum;

@Component({
  selector: 'cap-kompakt-personenadresse',
  templateUrl: './kompakt-personenadresse.component.html',
  styleUrls: ['./kompakt-personenadresse.component.scss'],
  imports: [NgTemplateOutlet, NgbTooltip, LinkComponent, UpperCasePipe, TranslatePipe]
})
export class KompaktPersonenadresseComponent extends KompaktdarstellungTemplateComponent {
  @Input() item: PersonAdresseListEntryMeta;
  @Input() entry: PersonStammVersionDetailEntryMeta | ZentralePersonDetailEntryMeta;
  @Input() isEigentuemer = false;
  @Input()
  link: LinkTargetWithParamsAndTooltip;

  @ViewChild('typ00', { static: true }) typ00Template: TemplateRef<any>;

  @ViewChild('typ01', { static: true }) typ01Template: TemplateRef<any>;
  hasPermissionAdresse: boolean;
  hasAdresssperre: boolean;
  showAdressen: boolean = false;

  constructor(
    protected formatService: FormatConfigService,
    protected location: PlatformLocation,
    protected componentLocation: ComponentLocationStrategy,
    protected formatAdressPipe: FormatPersonstammAddressPipe,
    private translate: TranslateService,
    private capAlertService: CapAlertService,
    private appPersmissionService: AppPermissionService
  ) {
    super(formatService, 'PERSONENADRESSE', location, componentLocation);
    keysToTranslate<string>(['AdresseWurdeKopiert', 'AdresseKopieren']);
    this.hasPermissionAdresse = this.appPersmissionService.hasPermission(PermissionsEnum.ADRESSSPERRE);
    this.showAdressen =
      !this.hasAdresssperre || (this.hasAdresssperre && this.hasPermissionAdresse) || (this.hasAdresssperre && this.isEigentuemer);
  }

  @Input()
  set auskunftsperre(value: PersonStammMasterDetailEntryMeta.AuskunftsperreEnum) {
    this.hasAdresssperre = value === PersonStammMasterDetailEntryMeta.AuskunftsperreEnum.ADRESS_SPERRE;
  }

  getDefaultTemplate(): TemplateRef<any> {
    return this.typ00Template;
  }

  registerTemplates() {
    this.bindTemplates(this.typ00Template, 'PERSONENADRESSE_TYP00');
    this.bindTemplates(this.typ01Template, 'PERSONENADRESSE_TYP01');
  }

  copyToClipboard() {
    const address = this.formatAdressPipe.transform(this.entry, this.item);
    Clipboard.copy(address);
    this.capAlertService.info(this.translate.instant('AdresseWurdeKopiert'));
  }

  getTooltip(): string {
    const adress = this.formatAdressPipe.transform(this.entry, this.item);
    return this.translate.instant('AdresseKopieren') + ': \n\n' + adress;
  }
}
